import React, { Component } from 'react';
import "./footer.css";

class Footer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            title: ""
        };

        this.onRouteChanged = this.onRouteChanged.bind(this);
    };

    componentWillMount() {
        window.addEventListener("onRouteChanged", this.onRouteChanged);
    };

    componentWillUnmount() {
        window.removeEventListener("onRouteChanged", this.onRouteChanged);
    };

    onRouteChanged(event) {
        let route = event.detail.route || event.detail.parentRoute || null;
        if (route) {
            this.setState({ title: route.title });
        }
    };

    render() {
        return (
            <footer className="footer-content">
                <small>
                    &copy;{new Date().getFullYear()} Discover, a division of Capital One, N.A., Member FDIC
                </small>
            </footer>
        );
    }
}

export default Footer;
